import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _BackupState } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { FileService } from "../../../../core/services/FileService";

interface Props {
    IDDocument: number;
    documentDate: any;
}

export const BackupCatalogByState = ({ IDDocument, documentDate }: Props) => {

    const BackupState = useDataBean(_BackupState);
    const fileService = new FileService();
    const single = Singleton.getInstance();
    const [formatourl, setFormatourl] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [modaldoc, setModaldoc] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDDocument, documentDate])

    const getLista = () => {

        BackupState.instance.getDocumentVersionBackupCatalogByState(IDDocument, documentDate).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    // setFormatourl(resp[0]);
                    setLista(tmp);
                } else {
                    setLista([]);
                }
            }
        )

    }

    const create = () => {
        BackupState.setBean({
            IDDocument: IDDocument
        });
        setModal({ ...modal, "view": true });
    }
    // const deleteItem = () => {
    //     BackupState.instance.deleteSubProcess(BackupState.bean).then(
    //         (resp: any) => {
    //             getLista();
    //             setModalC({ ...modalC, "view": false });
    //         }
    //     )

    // }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        BackupState.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDDocumentVersionBackup', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Usuario Moficia', property: 'EmployeeName', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Fecha Actualizada', property: 'NewUpdateDate', visible: true },
        { title: 'Documento', property: 'URL', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
        { title: 'Fecha Actualización', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModaldoc({ ...modaldoc, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={BackupState.setBean} ></BasicTable>
                <Modal modal={modaldoc} updateModal={setModaldoc}>
                    <>
                        <div className="row">
                            {/* <div className="col-md-6">
                                <BasicButton eventClick={exportProductionOrdersbyaccion} icon="ri-inbox-archive-line" children={"Exportar a Excel Ordenes de Producción"} />
                            </div> */}

                            <div className="col-md-12">
                                {formatourl?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <a href={formatourl.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>📄 {formatourl.DataBeanProperties.URLLink}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>

                    </>
                </Modal>
            </div>

        </div>
    )
}